import { React } from '@gravityforms/libraries';
import useIdUtil from '../hooks/use-id';

const { createContext, useContext } = React;

const IdContext = createContext( null );

/**
 * @function useIdContext
 * @description Uses the id context to access the id value.
 *
 * @since 4.0.1
 *
 * @return {string|null} The id value.
 */
export const useIdContext = () => useContext( IdContext );

/**
 * @module IdProvider
 * @description The id provider component.
 *
 * @since 4.0.1
 *
 * @param {object}      props          The props for the component.
 * @param {JSX.Element} props.children The children to render.
 * @param {string}      props.id       The id of the component.
 *
 * @return {JSX.Element} The id provider.
 */
export const IdProvider = ( { children, id: idProp = '' } ) => {
	const id = useIdUtil( idProp );
	return (
		<IdContext.Provider value={ id }>
			{ children }
		</IdContext.Provider>
	);
};
